export default {
  setLoading(state, payload) {
    state.loading = payload
  },
  setExerciseDefinition(state, payload) {
    state.exerciseDefinition = payload
  },
  setExerciseDefinitions(state, payload) {
    state.exerciseDefinitions = payload
  },
  setDialogExerciseDefinitions(state, payload) {
    state.dialogExerciseDefinitions = payload
  },
  setPagination(state, payload) {
    state.pagination = { ...payload }
  },
  setDialogPagination(state, payload) {
    state.dialogPagination = { ...payload }
  },
  setSequenceDefinitions(state, payload) {
    state.sequenceDefinitions = payload
  },
  setProfilePreviews(state, payload) {
    state.profilePreviews = payload
  },
  setSequenceDefinition(state, payload) {
    state.sequenceDefinition = { ...payload }
  },
  setSequencesFilters(state, payload) {
    state.sequencesFilters = payload
  },
  setExercisesFilters(state, payload) {
    state.exercisesFilters = payload
  },
  setDialogExercisesFilters(state, payload) {
    state.dialogExercisesFilters = payload
  },
  setExerciseFolders(state, payload) {
    state.exerciseFolders = payload
  },
  setSequenceFolders(state, payload) {
    state.sequenceFolders = payload
  },
  setDialogSequenceDefinitions(state, payload) {
    state.dialogSequenceDefinitions = payload
  },
  setDialogSequencesFilters(state, payload) {
    state.dialogSequencesFilters = payload
  },
  setSharingCompanies(state, payload) {
    state.sharingCompanies = payload
  },
  setRoutineDefinitionFoldersSharedList(state, payload) {
    state.routineDefinitionFoldersSharedList = payload
  },
  setDuplicatedCompanies(state, payload) {
    state.duplicatedCompanies = payload
  },
  setLoadingSequenceDefinitionParticipants(state, payload) {
    state.loadingSequenceDefinitionParticipants = payload
  },
  setSequenceDefinitionParticipants(state, payload) {
    state.sequenceDefinitionParticipants = payload
  },
  setSequenceDefinitionParticipantsPagination(state, payload) {
    state.sequenceDefinitionParticipantsPagination = payload
  },
}
